import { IconMinus, IconPlus, IconTrashFilled } from '@tabler/icons-react';
import React, { useContext, useRef, useState } from 'react';
import { Accordion } from 'react-bootstrap';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import AccordionContext from 'react-bootstrap/AccordionContext';
import ToggleBtn from '../../../../components/Toggle/ToggleBtn';
import { toast } from 'sonner';
import { postApi } from '../../../../api/call.api';
import { urlApi } from '../../../../api/url.api';
import { loadingHide, loadingShow } from '../../../../loadingUi/loading.controller';
import { uploadImage } from '../../../../api/api.global';
import ConfirmationModal from '../../../../components/ConfirmationModal/ConfirmationModal';

const ImageBlockOfCard = ({ dragButton, linkId, callback, data }) => {

    const [file, setFile] = useState(null);
    const imageUploadInputRef = useRef(null);

    function ContextAwareToggle({ eventKey, callback }) {
        const { activeEventKey } = useContext(AccordionContext);

        const decoratedOnClick = useAccordionButton(
            eventKey,
            () => callback && callback(eventKey),
        );

        const isCurrentEventKey = activeEventKey === eventKey;

        return (
            <div className="flex items-center rounded-md bg-[#E8EDFC] gap-3 p-2 cursor-pointer" onClick={decoratedOnClick}>
                {dragButton}
                <p className='mb-0 text-sm font-semibold'>Images</p>
                <div className="ms-auto"></div>
                <ToggleBtn state={data?.status == 1} onClickFunction={(e) => onBlockStatusUpdate(e)} />
                <button className='bg-white p-1.5 rounded-full' onClick={decoratedOnClick}>{isCurrentEventKey ? <IconMinus size={20} /> : <IconPlus size={20} />}</button>
            </div>
        );
    }

    const handleImageChange = (e) => {
        const localFile = e.target.files[0];
        const maxSizeInBytes = 1024 * 1024 * 5;
        if (localFile && localFile.size > maxSizeInBytes) {
            toast.error('File size exceeds the limit of 5MB.');
            setFile(null);
            e.target.value = null;
        } else {
            setFile(localFile);
            onImageUpload(localFile);
        }
    }

    async function update(postDetails) {
        let postData = {
            linkId: linkId,
            postData: postDetails
        }
        let resp = await postApi(postData, urlApi.editBlockDataOfCard);
        loadingHide();
        if (resp?.responseCode === 200) {
            if (callback) {
                callback();
            }
        }
        if (resp.responseCode === 500) {
            toast.error(resp.message);
        }
    }

    const onBlockStatusUpdate = (e) => {
        e.stopPropagation();
        loadingShow();
        let status = data?.status == 1 ? 2 : 1;
        let postDetails = [{
            "key": "images.status",
            "value": status
        }]
        update(postDetails);
    }

    const onViewTypeChange = (type) => {
        loadingShow();
        let postDetails = [{
            "key": "images.viewType",
            "value": type
        }]
        update(postDetails);
    }

    const onImageUpload = async (image) => {
        loadingShow();
        let existing = data?.imageArray || [];
        existing.push({ imageUrl: await uploadImage(image, 'advy-business-card'), imageStatus: true });
        let postDetails = [{
            "key": "images.imageArray",
            "value": existing
        }]
        update(postDetails);
    }

    const deleteImage = async (imageId) => {
        loadingShow();
        let postData = {
            "linkId": linkId,
            "imageId": imageId,
            "updateValue": false
        }
        let resp = await postApi(postData, urlApi.deleteImageOfCard);
        loadingHide();
        if (resp.responseCode == 200) {
            if (callback) {
                callback();
            }
        } else {
            toast.error(resp.message);
        }
    }

    return (

        <div className='w-full rounded-md overflow-hidden border border-[#E8EDFC]'>
            <Accordion>
                <Accordion.Item eventKey="0">
                    <ContextAwareToggle eventKey={"0"} />
                    <Accordion.Body>
                        <div className="p-2">
                            <p className="text-xs font-extralight mb-1.5">View Type</p>
                            <div className="flex gap-3 mb-4">
                                <button onClick={() => onViewTypeChange(1)} className={`${data?.viewType == 1 && 'border-primary border-2 rounded-md p-0.5'}`}> <img src={process.env.PUBLIC_URL + "/images/business-card/image-template-1.png"} alt="" /> </button>
                                <button onClick={() => onViewTypeChange(2)} className={`${data?.viewType == 2 && 'border-primary border-2 rounded-md p-0.5'}`}> <img src={process.env.PUBLIC_URL + "/images/business-card/image-template-2.png"} alt="" /> </button>
                                <button onClick={() => onViewTypeChange(3)} className={`${data?.viewType == 3 && 'border-primary border-2 rounded-md p-0.5'}`}> <img src={process.env.PUBLIC_URL + "/images/business-card/image-template-3.png"} alt="" /> </button>
                            </div>
                            <p className="text-xs font-extralight mb-3">Photos ( Max 9 Images ) ( 1:1 or 4:5 Ratio )</p>
                            <div className="flex gap-3 flex-wrap">
                                {
                                    data?.imageArray?.map((item, index) => {
                                        return (
                                            <div key={index} className='relative'>
                                                <ConfirmationModal buttonComponent={<button className='absolute z-[1] bg-red-600 p-1 rounded-full -top-2 -right-2'> <IconTrashFilled color='white' size={16} /> </button>} confirmationText={'Are you sure want to delete this Image?'} onConfirm={() => deleteImage(item?._id)} />
                                                <img src={item?.imageUrl} className='w-16 aspect-square rounded-md shadow-md object-cover' alt="" />
                                            </div>
                                        )
                                    })
                                }
                                {/* {file && <img src={file && URL.createObjectURL(file)} className='w-16 aspect-square rounded' id='image-preview' alt="" />} */}

                                <input type="file" accept="image/png, image/jpeg, image/svg, image/jpg, image/webp" name="" id="" className="hidden" onChange={handleImageChange} ref={imageUploadInputRef} />
                                {data?.imageArray?.length < 9 && <button onClick={() => imageUploadInputRef.current.click()}>
                                    <img src={process.env.PUBLIC_URL + "/images/image-upload-2.png"} className='w-16 aspect-square shadow-md' alt="" />
                                </button>}
                            </div>
                        </div>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </div>
    )
}

export default ImageBlockOfCard